import { render, staticRenderFns } from "./GroupInfoPopup.vue?vue&type=template&id=a089dc50&scoped=true"
import script from "./GroupInfoPopup.vue?vue&type=script&lang=js"
export * from "./GroupInfoPopup.vue?vue&type=script&lang=js"
import style0 from "./GroupInfoPopup.vue?vue&type=style&index=0&id=a089dc50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a089dc50",
  null
  
)

export default component.exports